/**
 * @generated SignedSource<<615cc6f909bad1cb2f6e93c4962dcb99>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CaddieConfirmationStatus = "CONFIRMED" | "UNCONFIRMED";
export type ClientClass = "CUSTOMER" | "MEMBER";
export type ManualPaymentStatus = "AUTO_CHARGE" | "MARKED_PAID" | "PAYMENT_EXPECTED";
export type NoShowStatus = "CHARGE" | "EXEMPT" | "PAID" | "PRESENT";
export type CreateRequestBookingInput = {
  bookingAudience?: ClientClass | null | undefined;
  customerRounds?: ReadonlyArray<CreateCustomerRoundInput | null | undefined> | null | undefined;
  durationMins?: number | null | undefined;
  guestRounds?: ReadonlyArray<CreateGuestRoundInput | null | undefined> | null | undefined;
  instructors?: ReadonlyArray<string | null | undefined> | null | undefined;
  isDraft?: boolean | null | undefined;
  memberRounds?: ReadonlyArray<CreateMemberRoundInput | null | undefined> | null | undefined;
  newCustomerRounds?: ReadonlyArray<NewCustomerRoundInput | null | undefined> | null | undefined;
  newGuestRounds?: ReadonlyArray<NewGuestRoundInput | null | undefined> | null | undefined;
  notesFromMember?: string | null | undefined;
  notesFromStaff?: string | null | undefined;
  notifyMember?: boolean | null | undefined;
  paymentCardOnFileId?: string | null | undefined;
  request: RequestInput;
  startSlotId: string;
};
export type CreateMemberRoundInput = {
  bookingIndex?: number | null | undefined;
  caddieConfirmationStatus?: CaddieConfirmationStatus | null | undefined;
  caddieId?: string | null | undefined;
  cartNumber?: string | null | undefined;
  checkedIn?: boolean | null | undefined;
  courseLayoutId?: string | null | undefined;
  index?: number | null | undefined;
  manualPaymentStatus?: ManualPaymentStatus | null | undefined;
  noShowStatus?: NoShowStatus | null | undefined;
  nonPlayingHost?: boolean | null | undefined;
  playerId?: string | null | undefined;
  postable?: boolean | null | undefined;
  rateId?: string | null | undefined;
  secondaryTransportationTypeId?: string | null | undefined;
  transportationTypeId?: string | null | undefined;
};
export type CreateCustomerRoundInput = {
  bookingIndex?: number | null | undefined;
  caddieConfirmationStatus?: CaddieConfirmationStatus | null | undefined;
  caddieId?: string | null | undefined;
  cartNumber?: string | null | undefined;
  checkedIn?: boolean | null | undefined;
  courseLayoutId?: string | null | undefined;
  index?: number | null | undefined;
  manualPaymentStatus?: ManualPaymentStatus | null | undefined;
  noShowStatus?: NoShowStatus | null | undefined;
  playerId?: string | null | undefined;
  rateId?: string | null | undefined;
  secondaryTransportationTypeId?: string | null | undefined;
  transportationTypeId?: string | null | undefined;
};
export type CreateGuestRoundInput = {
  bookingIndex?: number | null | undefined;
  caddieConfirmationStatus?: CaddieConfirmationStatus | null | undefined;
  caddieId?: string | null | undefined;
  cartNumber?: string | null | undefined;
  checkedIn?: boolean | null | undefined;
  courseLayoutId?: string | null | undefined;
  index: number;
  manualPaymentStatus?: ManualPaymentStatus | null | undefined;
  name?: string | null | undefined;
  noShowStatus?: NoShowStatus | null | undefined;
  playerId?: string | null | undefined;
  rateId?: string | null | undefined;
  secondaryTransportationTypeId?: string | null | undefined;
  transportationTypeId?: string | null | undefined;
};
export type NewGuestRoundInput = {
  bookingIndex?: number | null | undefined;
  caddieConfirmationStatus?: CaddieConfirmationStatus | null | undefined;
  caddieId?: string | null | undefined;
  cartNumber?: string | null | undefined;
  checkedIn?: boolean | null | undefined;
  courseLayoutId?: string | null | undefined;
  email?: string | null | undefined;
  id?: string | null | undefined;
  index: number;
  manualPaymentStatus?: ManualPaymentStatus | null | undefined;
  name: string;
  noShowStatus?: NoShowStatus | null | undefined;
  playerId?: string | null | undefined;
  rateId?: string | null | undefined;
  secondaryTransportationTypeId?: string | null | undefined;
  transportationTypeId?: string | null | undefined;
};
export type NewCustomerRoundInput = {
  bookingIndex?: number | null | undefined;
  caddieConfirmationStatus?: CaddieConfirmationStatus | null | undefined;
  caddieId?: string | null | undefined;
  cartNumber?: string | null | undefined;
  checkedIn?: boolean | null | undefined;
  courseLayoutId?: string | null | undefined;
  email?: string | null | undefined;
  firstName: string;
  id?: string | null | undefined;
  index: number;
  lastName: string;
  manualPaymentStatus?: ManualPaymentStatus | null | undefined;
  noShowStatus?: NoShowStatus | null | undefined;
  phoneNumber?: string | null | undefined;
  rateId?: string | null | undefined;
  secondaryTransportationTypeId?: string | null | undefined;
  transportationTypeId?: string | null | undefined;
};
export type RequestInput = {
  bookingRuleId?: string | null | undefined;
  id?: string | null | undefined;
  maxTime: string;
  minTime: string;
  requestCoursePreferences?: ReadonlyArray<RequestCoursePreferenceInput> | null | undefined;
  time: string;
};
export type RequestCoursePreferenceInput = {
  courseBucketId?: string | null | undefined;
  courseId?: string | null | undefined;
};
export type useCreateNewRequestBookingMutation$variables = {
  input: CreateRequestBookingInput;
};
export type useCreateNewRequestBookingMutation$data = {
  readonly responsePayload: {
    readonly booking: {
      readonly id: string;
    } | null | undefined;
    readonly errors: ReadonlyArray<{
      readonly code: string;
      readonly field: ReadonlyArray<string | null | undefined>;
      readonly message: string | null | undefined;
    } | null | undefined>;
    readonly success: boolean;
  } | null | undefined;
};
export type useCreateNewRequestBookingMutation = {
  response: useCreateNewRequestBookingMutation$data;
  variables: useCreateNewRequestBookingMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "field",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "success",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useCreateNewRequestBookingMutation",
    "selections": [
      {
        "alias": "responsePayload",
        "args": (v1/*: any*/),
        "concreteType": "CreateRequestBookingPayload",
        "kind": "LinkedField",
        "name": "createRequestBooking",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "booking",
            "plural": false,
            "selections": [
              (v6/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useCreateNewRequestBookingMutation",
    "selections": [
      {
        "alias": "responsePayload",
        "args": (v1/*: any*/),
        "concreteType": "CreateRequestBookingPayload",
        "kind": "LinkedField",
        "name": "createRequestBooking",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v7/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "booking",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              (v6/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "19eecad032fb25f0f6e88c779f9678dd",
    "id": null,
    "metadata": {},
    "name": "useCreateNewRequestBookingMutation",
    "operationKind": "mutation",
    "text": "mutation useCreateNewRequestBookingMutation(\n  $input: CreateRequestBookingInput!\n) {\n  responsePayload: createRequestBooking(input: $input) {\n    errors {\n      __typename\n      field\n      code\n      message\n    }\n    success\n    booking {\n      __typename\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "816327825ad16759336508d40c242855";

export default node;
